module.exports = __webpack_public_path__ + "static/media/radio-empty.1c749637.svg";